import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0002',
    ecrans: ['00-2'],
    params: ['id']
});
